var _polygon, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _path14, _path15, _circle2, _path16, _circle3, _path17, _path18, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawAttachedFileRe0N9B(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 744.10303,
    height: 540.06599,
    viewBox: "0 0 744.10303 540.06599",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "628.516 244.135 555.516 235.135 559.516 171.135 628.516 171.135 628.516 244.135",
    fill: "#ffb6b6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f547979f-30db-4d62-a257-d4bfbfe667e0",
    "data-name": "Group 234"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.00314,502.305a5.87684,5.87684,0,0,1-5.38672-3.55371L882.4797,475.10191l30.04541.1045,20.64356-21.83106,9.8999,23.11621a5.8826,5.8826,0,0,1-3.00488,7.66016l-39.68262,17.64453A5.84282,5.84282,0,0,1,898.00314,502.305Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.96066,478.18687q-.375,0-.75146-.02148l-24.14112-1.36621-.65332-1.46582.45655-.2041,50.21289-22.35938.65429,1.4668-15.3623,18.98242A13.43023,13.43023,0,0,1,907.96066,478.18687Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#ccc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ec5190b7-0dc9-4fc1-a6ea-a2851344a52e",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a41acc16-2a15-4b6f-9345-341b037288f3-178",
    "data-name": "Path 3126",
    d: "M865.4425,259.23624l-71.275.891a5.052,5.052,0,0,1-5.046-5.046v-23.55a37.567,37.567,0,1,1,75.134,0l6.234,22.659a5.052,5.052,0,0,1-5.046,5.046Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3d22c3d-6f1c-436e-b4fd-75bc616be34e-179",
    "data-name": "Path 3127",
    d: "M900.33734,468.62436a10.94289,10.94289,0,0,1,.646-16.767l-12.4-36.856,19.537,5.163,8.783,34.207a11,11,0,0,1-16.566,14.25305Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fe496b5f-eacb-49bf-835d-e5ac3c7bd013-180",
    "data-name": "Path 3128",
    d: "M815.82635,705.69938l-14.63-2.373,2.194-57.558,21.592,3.5Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "adde0c44-329e-48ad-9999-13284ac28796-181",
    "data-name": "Path 3130",
    d: "M888.73962,675.18473l-13.232,6.676-35.048-50.86,19.529-9.853Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ab67ec02-b830-445c-9023-1829e58b9383",
    "data-name": "Ellipse 597",
    cx: 598.42909,
    cy: 53.89992,
    r: 26.016,
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac700c97-6387-43c9-81e9-ad7c0d932a24-182",
    "data-name": "Path 3132",
    d: "M846.9765,656.69169l-60.929-155.364c-21.806-59.565-2.323-100.618-2.123-101.025l.1-.2.208-.076c2.50214,9.738,59.23206,9.07522,72.23206-5.92478,7.588,6.374,17.68692,21.38177,19.85092,39.31576a141.47277,141.47277,0,0,1-5.038,57.289l-24,81.36,29.693,66.891Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e883732b-3258-425b-994e-3a6a30ec2938-183",
    "data-name": "Path 3133",
    d: "M817.59528,560.32242l-22,111.556,29.3,5.525,18.435-96.562Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.46457,370.10191c4.687,1.252,51.019,20.34375,73,1l17.249-85.16406-20.66553-6.51807-7.21142-8.76953a8.18994,8.18994,0,0,0-6.44727-2.99218l-25.63623.34277a8.22868,8.22868,0,0,0-6,2.72705l-8.21191,9.15771-18.54883,4.3169Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a25c4561-38e3-49ca-954a-abf72052a615-184",
    "data-name": "Path 3135",
    d: "M867.84845,292.58066l5.61612-7.47875s10.28989,2.70376,15.51785,17.44875,26.64807,132.552,26.64807,132.552l-23.067,10.71-31.237-104.116Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a027b147-c881-4d9f-8b61-00879d10f14f-185",
    "data-name": "Path 3136",
    d: "M683.00519,432.87626a10.943,10.943,0,0,1,14.212-8.92l23.445-31.024,6.752,19.046-23.3,26.541a11,11,0,0,1-21.11-5.643Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f5b89bac-f8c6-4779-b05c-fe0d4c0fe303-186",
    "data-name": "Path 3137",
    d: "M791.23322,290.92985l-7.76865-6.82794s-8.13736,2.05294-13.36533,16.79794-71.958,113.6-71.958,113.6l23.067,10.71,76.548-85.168Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba40f7a0-bee8-41f1-97d8-6a2b5672d4e5-187",
    "data-name": "Path 3159",
    d: "M853.48749,232.15079h-36.363a2.807,2.807,0,0,1-2.782-2.456l-.471-3.766a1.682,1.682,0,0,0-3.193-.5l-2.385,5.104a2.814,2.814,0,0,1-2.54,1.617h-5.523a2.8,2.8,0,0,1-2.80414-2.79584q-.00027-.13784.01312-.27518l2.178-22.749a2.825,2.825,0,0,1,1.6-2.283c16.653-7.774,33.541-7.764,50.194.03a2.80813,2.80813,0,0,1,1.586,2.152l3.263,22.719a2.8,2.8,0,0,1-2.775,3.2Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#2f2e41"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a3cc64c2-abbc-45ce-be54-f5a6fdde0299-188",
    "data-name": "Path 3114",
    d: "M266.91948,197.963a4.776,4.776,0,0,0-4.781,4.759l-1.175,510.439a4.776,4.776,0,0,0,4.759,4.781l411.213.946a4.776,4.776,0,0,0,4.781-4.76l1.175-510.439a4.776,4.776,0,0,0-4.76-4.781Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "efbfa0e2-5865-4f91-9d47-e58aafc36f5f-189",
    "data-name": "Path 3115",
    d: "M282.15349,213.264a4.776,4.776,0,0,0-4.781,4.759l-1.1,479.908a4.776,4.776,0,0,0,4.759,4.781l380.682.876a4.776,4.776,0,0,0,4.781-4.759l1.1-479.908a4.776,4.776,0,0,0-4.76-4.781Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bdd7e382-c488-46e1-abb6-e0dcfe2b45ff-190",
    "data-name": "Path 3116",
    d: "M612.26351,421.659l-280.5-.645a7.156,7.156,0,0,1,.033-14.311l280.5.646a7.156,7.156,0,0,1-.033,14.311Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "a030302a-8aea-40b9-b209-283f220e96ee-191",
    "data-name": "Path 3117",
    d: "M614.97951,288.33l-186.094-.428c-2.622-.006-4.74-3.215-4.731-7.167s2.142-7.151,4.764-7.145l186.094.428c2.622.006,4.74,3.215,4.731,7.167S617.60146,288.34,614.97951,288.33Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "a8f20448-9372-4a75-b338-6e14c20e819a-192",
    "data-name": "Path 3118",
    d: "M614.88448,329.356l-186.094-.428c-2.622-.006-4.74-3.215-4.731-7.167s2.142-7.151,4.764-7.145l186.094.428c2.622.006,4.74,3.215,4.731,7.167S617.50649,329.362,614.88448,329.356Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "b6db1193-8bf6-43ce-8bbd-82156e7f6c80-193",
    "data-name": "Path 3119",
    d: "M612.15346,467.932l-280.5-.645a7.156,7.156,0,0,1,.033-14.311l280.5.645a7.156,7.156,0,1,1,.13251,14.3114q-.08277.00073-.16553-.0004Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "e8bd11eb-6651-49db-b69e-2aeb489d8156-194",
    "data-name": "Path 3120",
    d: "M612.05349,514.205l-280.5-.646a7.156,7.156,0,0,1,.033-14.311l280.5.646a7.156,7.156,0,1,1,.13525,14.31134q-.08414.00082-.16827-.00037Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "f336a5d0-52e6-422c-aaf1-5eee2a5d72af-195",
    "data-name": "Path 3121",
    d: "M611.94448,560.479l-280.5-.646a7.156,7.156,0,0,1,.033-14.311l280.5.646a7.156,7.156,0,0,1,.13531,14.31135q-.08414.00081-.16833-.00037Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "ac9f3bd3-9abe-42cb-b3e3-99cb75c73ae6-196",
    "data-name": "Path 3122",
    d: "M473.83748,604.752l-142.5-.646a7.156,7.156,0,0,1,.033-14.311l142.5.646a7.156,7.156,0,0,1,.13532,14.31134Q473.92169,604.75317,473.83748,604.752Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "f6760762-a9bc-4797-b1cd-005f4be61990-197",
    "data-name": "Path 3123",
    d: "M473.73146,651.026l-142.5-.646a7.156,7.156,0,0,1,.033-14.311l142.5.646a7.156,7.156,0,0,1,.1352,14.31134q-.08414.00082-.16822-.00036Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "b178569c-1ea7-4785-9e0a-4827d572b4f6-198",
    "data-name": "Path 3124",
    d: "M420.36049,421.217",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "e143acc2-6a50-448e-bf71-b0fcbdb3a8d4-199",
    "data-name": "Path 3125",
    d: "M553.45981,233.70177V199.65392a19.26315,19.26315,0,1,0-38.517-.84732h4.23851a15.04481,15.04481,0,0,1,15.01083-14.45829h.22071a15.05205,15.05205,0,0,1,14.80921,15.27392v34.35141a10.09034,10.09034,0,0,1-10.0762,9.95631h-.12411a10.09531,10.09531,0,0,1-9.954-10.22666l.02329-33.81874a5.0765,5.0765,0,1,1,10.153-.03323v9.82552a2.11925,2.11925,0,0,0,4.2385,0v-9.85911a9.31385,9.31385,0,1,0-18.62768.03207l-.02216,33.82638A14.33229,14.33229,0,0,0,538.974,248.165h.1764a14.33609,14.33609,0,0,0,14.3128-14.15052C553.46058,233.90529,553.46058,233.79456,553.45981,233.70177Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#ffffff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M611.46457,620.84234a47.09506,47.09506,0,0,1-2.96835,16.51433,45.80248,45.80248,0,0,1-3.28052,6.99436,47.31374,47.31374,0,0,1-82.101,0q-.629-1.09038-1.19294-2.2134a47.30326,47.30326,0,1,1,89.54279-21.29529Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e4e4e4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 338.6758,
    cy: 439.81776,
    r: 9.04267,
    fill: "#ffffff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M521.92183,642.13763c3.98413-4.30566,9.31028-11.14158,14.30559-6.2022,2.507,2.3299,6.43052,8.1034,10.18632,4.329l29.32878-29.32878a5.82252,5.82252,0,0,1,8.32707.14911l24.42667,26.272a45.81759,45.81759,0,0,1-3.2805,6.99436h-82.101Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M399.46457,299.84234a47.09506,47.09506,0,0,1-2.96835,16.51433,45.80248,45.80248,0,0,1-3.28052,6.99436,47.31374,47.31374,0,0,1-82.101,0q-.629-1.09038-1.19294-2.2134a47.30326,47.30326,0,1,1,89.54279-21.29529Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#e4e4e4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.6758,
    cy: 118.81776,
    r: 9.04267,
    fill: "#ffffff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M309.92183,321.13763c3.98413-4.30566,9.31028-11.14158,14.30559-6.2022,2.507,2.3299,6.43052,8.1034,10.18632,4.329l29.32878-29.32878a5.82252,5.82252,0,0,1,8.32707.14911l24.42667,26.272a45.81759,45.81759,0,0,1-3.2805,6.99436h-82.101Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.51608,
    cy: 55.13491,
    r: 5,
    fill: "#ffffff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M823.33883,719.10191h-9.51671l-1.69869-8.98489-4.35059,8.98489H782.53227a5.67385,5.67385,0,0,1-3.22407-10.3429l20.15637-13.92071v-9.08343l21.201,1.26541Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M907.667,696.82857l-7.99481,5.16242-6.301-6.62658,1.21908,9.90807-21.20415,13.692a5.67385,5.67385,0,0,1-8.31908-6.94l9.38158-22.62855-4.92739-7.63082,18.497-10.43762Z",
    transform: "translate(-227.94849 -179.967)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "ec7b4546-a015-4f0c-8a9e-c44dd1859d9d",
    "data-name": "Rectangle 462",
    y: 538.06599,
    width: 744.10303,
    height: 2,
    fill: "#ccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawAttachedFileRe0N9B);
export default __webpack_public_path__ + "static/media/undraw_attached_file_re_0n9b.1c9ddf726ca94c4f25a977dcb3734f7c.svg";
export { ForwardRef as ReactComponent };